import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M10.8 2.8v14.6L5.5 12l-1.4 1.4 7.7 7.7 7.7-7.7-1.4-1.4-5.3 5.3V2.8h-2z" }));
export {
  o as ReactComponent
};
